import { getServiceHomePath, getServiceHomeUrl } from '../constants/route';
import { CirraServiceType } from '../enums/auth';
import { useLocation } from 'react-router-dom';

interface RoutingInfo {
  service: CirraServiceType;
  isOnAdminAgentPage: boolean;
  isOnChangeAgentPage: boolean;
  isOnMcpPage: boolean;
  homeUrl: string;
  homePath: string;
}

const DEFAULT_SERVICE = CirraServiceType.MCP;

export const useRouting = (): RoutingInfo => {
  const location = useLocation();

  const isOnAdminAgentPage = location.pathname.includes('/admin-agent');
  const isOnChangeAgentPage = location.pathname.includes('/change-requests');
  const isOnMcpPage = location.pathname === '/' || location.pathname === '/mcp';

  let service = DEFAULT_SERVICE;
  if (isOnAdminAgentPage || isOnChangeAgentPage) {
    service = CirraServiceType.AGENTS;
  } else {
    service = CirraServiceType.MCP;
  }

  return {
    service,
    isOnAdminAgentPage,
    isOnChangeAgentPage,
    isOnMcpPage,
    homeUrl: getServiceHomeUrl(service),
    homePath: getServiceHomePath(service).path,
  };
};
